import { call, select } from 'redux-saga/effects';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';

import { selectActiveVenueId, selectRouteParams, selectUserInfo, selectUserIsAuthenticated } from 'selectors/general';
import { selectLocaleData } from 'selectors/locale-data';
import { makePath, getTermsUrl } from 'helpers/link-generation';
import { getVenuesList } from 'helpers/active-venue';
import { cmsLegalContent } from 'store/saga/entities/bound';

export function* redirectFromHelp(client) {
  const isAuthenticated = yield select(selectUserIsAuthenticated);
  const { locale } = yield select(selectLocaleData);

  if (isAuthenticated) {
    const activeVenueId = yield select(selectActiveVenueId);
    yield call(client.navigate, makePath.contactUs(activeVenueId, locale));
  } else {
    yield call(client.navigate, makePath.login());
  }
}

export function* redirectFromHelpTerms(client) {
  const activeVenueId = yield select(selectActiveVenueId);
  const user = yield select(selectUserInfo);
  const venuesList = getVenuesList(user);

  yield call(client.navigate, getTermsUrl(venuesList, activeVenueId));
}

export function* handleLegalContentCmsEnter(client) {
  const { slug } = yield select(selectRouteParams);
  yield call(fetchEntityIfNeeded, cmsLegalContent, [client, slug]);
}
